import React from "react";
import { Link, Navigate, Outlet } from "react-router-dom";
import { Button, Col, Divider, Image, Layout, Modal, Row, Steps } from "antd";

import { IoHomeOutline, IoLogOutOutline, IoMenu, IoPersonOutline } from 'react-icons/io5';

import { ExclamationCircleOutlined } from '@ant-design/icons';

import { POST_API, POST_CATCH, delToken, getToken } from "../services/hello-api";

import Pageload from "../components/Pageload";
import PlataformaMenu from "../components/Menus/PlataformaMenu";

import logo from '../assets/images/newlogo.png';
import AgenciaMenu from "../components/Menus/AgenciaMenu";

import { IoAlbums, IoApps, IoArrowBackCircle, IoBusiness, IoClipboard, IoCloseCircle, IoGrid, IoMap, IoPeople, IoMan, IoSettings, IoIdCard, IoCalendar, IoDocument, IoBook, IoCalculator } from "react-icons/io5";
import { RiGraduationCapFill } from "react-icons/ri";
import FormandoMenu from "../components/Menus/FormandoMenu";

class Dashboard extends React.Component {

    state = { _loading: true, _navigate: false, _user: null, _menu: false, current: 0 }

    componentDidMount = () => {
        if (getToken()) {
            POST_API('/credential/verify.php', { token: getToken() }).then(rs => rs.json()).then(res => {
                if (!res.return) {
                    this.setState({ _navigate: true })
                } else {
                    this.setState({ _user: res.user })
                }
            }).catch(() => POST_CATCH()).finally(() => {
                this.setState({ _loading: false })
            })
        } else {
            this.setState({ _navigate: true })
        }
    }

    onMenu = () => {
        this.setState({ _menu: !this.state._menu })
    }

    onLogOut = () => {
        var self = this
        Modal.confirm({
            title: 'Sair do sistema?',
            icon: <ExclamationCircleOutlined />,
            cancelText: 'Não',
            okText: 'Sim',
            onOk() { delToken(); self.setState({ _navigate: true }) },
            onCancel() { },
        })
    }

    onChangeStep = (value) => {
        this.setState({ current: value })
    }

    render = () => {

        if (this.state._navigate) return <Navigate to="/" />

        if (this.state._user === null) return <Pageload />

        return (
            <Layout.Content>
                <Row className="dashboard-row">
                    <Col flex={'250px'} className="row-pc border shadow">
                        <Row gutter={[8, 8]} style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 10 }}>
                            <Col span={24}>
                                <Image src={logo} preview={false} />
                            </Col>
                            <Col span={24}>
                                <Row justify={'space-around'} align={'middle'}>
                                    <Link to="/dashboard"><Col><Button shape="circle" type="link"><IoHomeOutline size={18} color="var(--fourth)" /></Button></Col></Link>
                                    <Link to="perfil"><Col><Button shape="circle" type="link"><IoPersonOutline size={18} color="var(--fourth)" /></Button></Col></Link>
                                    <Col><Button onClick={this.onLogOut} shape="circle" type="link"><IoLogOutOutline size={18} color="var(--fourth)" /></Button></Col>
                                </Row>
                            </Col>
                            {this.state._user.TYPE_ACCOUNT_ID === "1" ? <PlataformaMenu onMenu={this.onMenu} type="pc" /> : null}
                            {this.state._user.TYPE_ACCOUNT_ID === "2" && this.state._user.TYPE_CREDENTIAL === "O" ? <AgenciaMenu onMenu={this.onMenu} type="pc" /> : null}
                            {this.state._user.TYPE_ACCOUNT_ID === "2" && this.state._user.TYPE_CREDENTIAL === "P" ? <FormandoMenu onMenu={this.onMenu} type="pc" /> : null}
                        </Row>
                    </Col>
                    <Col flex={'auto'} className="dashboard-content">
                        <Outlet />
                    </Col>
                    <Col xs={24} md={0} className="dashboard-menu">
                        <Row justify={'space-around'} align={'middle'} className="dashboard-menu-row">
                            <Col><Button shape="circle" type="link" onClick={this.onMenu}><IoMenu size={26} color="var(--fourth)" /></Button></Col>
                            <Link to="/dashboard"><Col><Button shape="circle" type="link"><IoHomeOutline size={26} color="var(--fourth)" /></Button></Col></Link>
                            {/* <Col><Button shape="circle" type="link"><IoChatboxEllipsesOutline size={26} color="var(--fourth)" /></Button></Col> */}
                            <Link to="perfil"><Col><Button shape="circle" type="link"><IoPersonOutline size={26} color="var(--fourth)" /></Button></Col></Link>
                            <Col><Button onClick={this.onLogOut} shape="circle" type="link"><IoLogOutOutline size={26} color="var(--fourth)" /></Button></Col>
                        </Row>
                    </Col>
                    <Col xs={24} md={0} className={this.state._menu ? "dashboard-submenu active" : "dashboard-submenu"}>
                        {this.state._user.TYPE_ACCOUNT_ID === "1" ? <PlataformaMenu onMenu={this.onMenu} type="app" /> : null}
                        {this.state._user.TYPE_ACCOUNT_ID === "2" && this.state._user.TYPE_CREDENTIAL === "O" ? <AgenciaMenu onMenu={this.onMenu} type="app" /> : null}
                        {this.state._user.TYPE_ACCOUNT_ID === "2" && this.state._user.TYPE_CREDENTIAL === "P" ? <FormandoMenu onMenu={this.onMenu} type="app" /> : null}
                    </Col>
                </Row>
            </Layout.Content>
        )
    }

}

export default Dashboard;